import { h, Component } from "preact";
import PropTypes from "prop-types";
import { connect } from "preact-redux";
import { getDashboard } from "../actions";
import UserDashboard from "../components/UserDashboard";

import styles from "./DashboardPage.scss";
import { HappinessMenu, menuOptions } from "../../menu";
import { isManager } from "../../../support/auth";
import { Input } from "semantic-ui-react";
import { ON_MOBILE_DEVICE } from "../../../config";
import DashboardExport from "../components/dashboard-export/DashboardExport";

export class DashboardPage extends Component {
  constructor(props) {
    super(props);
    isManager();
    this.props.getDashboard();

    this.state = {
      searchQuery: "",
    };

    this.onTextChanged = this.onTextChanged.bind(this);
  }

  onTextChanged(value) {
    this.setState({ searchQuery: value });
  }

  render() {
    const { dashboardData } = this.props;
    const menuComponents = [
      <Input
        key="search"
        className={styles.input}
        onChange={e => this.onTextChanged(e.target.value)}
        value={this.state.searchQuery}
        placeholder="Search users"
        icon="search"
      />,
      !ON_MOBILE_DEVICE() && (
        <DashboardExport key="export" dashboardData={dashboardData} />
      ),
    ];
    const menu = (
      <HappinessMenu
        headerText={"Dashboard"}
        componentsToRender={menuComponents}
        selectedPage={menuOptions.DASHBOARD_PAGE}
      />
    );

    const components = [
      ON_MOBILE_DEVICE() && menuComponents,
      <UserDashboard
        key="dash"
        dashboardData={dashboardData}
        searchQuery={this.state.searchQuery}
      />,
    ];

    ON_MOBILE_DEVICE() ? components.push(menu) : components.unshift(menu);

    return <div className={styles.container}> {components} </div>;
  }
}

DashboardPage.PropTypes = {
  dashboardData: PropTypes.array.isRequired,
  getDashboard: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  dashboardData: state.dashboard.dashboardData,
});

const mapDispatchToProps = {
  getDashboard,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardPage);



// WEBPACK FOOTER //
// ./src/modules/dashboard/pages/DashboardPage.js